import React, { useState, useEffect } from "react";
import Notice from "../../components/Notice";
import { search, filterByStatus } from "../../components/Pharmacies/utils";
import PharmacySearch from "../../components/Pharmacies/PharmacySearch";

const NETWORKS = ["orserdu"];

export default function StemlinePharmacyTable({
  pharmacies: initialPharmacies,
  eligibility: initialEligibility,
}) {
  const [searchTerms, setSearchTerms] = useState({
    searchQuery: "",
    filterQuery: [],
  });
  const pharmacies = initialPharmacies;
  const eligibility = initialEligibility;
  const notice = {
    kind: "error",
    open: false,
    message: "",
  };

  useEffect(() => {
    filterPharmacies();
  }, [searchTerms]);

  const filterPharmacies = () => {
    return searchTerms.filterQuery.length > 0
      ? filterByStatus(pharmacies, searchTerms, eligibility, NETWORKS)
      : search(pharmacies, searchTerms);
  };

  const renderEligibilityTag = (status) => {
    const statusMap = {
      IN_PROCESS: "green",
      ELIGIBLE: "green",
      AT_RISK: "orange",
      INELIGIBLE: "red",
      INELIGIBLE_MISSING_CLAIMS: "red",
    };

    if (!status) return null;

    return (
      <div className="badge">
        <div className={`badge__indicator badge__indicator--${statusMap[status] || "gray"}`} />
        {status.replace(/_/g, " ")}
      </div>
    );
  };

  const renderPharmacyNetworkStatus = (pharmacy, network) => {
    const pharmacyEligibility = eligibility[pharmacy.pharmacy_id];
    const status = pharmacyEligibility?.[network];
    return renderEligibilityTag(status);
  };

  const renderPharmacies = () =>
    filterPharmacies().map((pharmacy, i) => (
      <tr key={i} className="sm">
        <td className="t--md">
          <div className="t--sm t--500">{pharmacy.pharmacy_name}</div>
          <div className="t--sm t--subtitle">{pharmacy.address}</div>
        </td>
        <td className="t--sm">{pharmacy.dea}</td>
        {NETWORKS.map((network) => (
          <td key={network} className="t--md">
            {renderPharmacyNetworkStatus(pharmacy, network)}
          </td>
        ))}
      </tr>
    ));

  return (
    <div>
      <div className="table__actionbar table__actionbar--spacebetween">
        <div className="table__actionbar__vertical_stack">
          <div className="section__title">Contracted Pharmacies</div>
          <PharmacySearch
            searchTerms={searchTerms}
            setSearchTerms={setSearchTerms}
            filterable={true}
          />
        </div>
      </div>

      <div className="table__container" style={{ padding: "0 5px", marginBottom: 50 }}>
        <table className="primary">
          <thead>
            <tr className="sm">
              <th>Pharmacy</th>
              <th>DEA</th>
              {NETWORKS.map((network) => (
                <th key={network}>
                  {network == "retail" ? "status" : network.charAt(0) + network.slice(1)}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>{renderPharmacies()}</tbody>
        </table>
      </div>
      <Notice details={notice} />
    </div>
  );
}
